<template>
  <b-row>
    <transition name="bounce">
      <b-col md="12">
        <div class="card">
          <h1 class="card-title p-4">Informacion del Usuario</h1>
          <div class="card-body">
            <b-row>
              <b-col md="4" class="flex-container">
                <span class="badge badge-secondary">
                  nombre: <strong>{{ user.nombre }}</strong>
                </span>
                <span class="badge badge-secondary">
                  usuario: <strong>{{ user.usuario }}</strong>
                </span>
                <span class="badge badge-secondary">
                  codigo empresa: <strong>{{ user.codempresa }}</strong>
                </span>
                <span class="badge badge-secondary">
                  telefono: <strong>{{ user.telefono }}</strong>
                </span>
                <span class="badge badge-secondary">
                  email: <strong>{{ user.email }}</strong>
                </span>
                <span class="badge badge-secondary">
                  sector: <strong>{{ user.sector }}</strong>
                </span>
                <span class="badge badge-secondary">
                  cor: <strong>{{ user.cor }}</strong>
                </span>
                <span class="badge badge-secondary">
                  roles: <strong>{{ user.roles.name }}</strong>
                </span>
              </b-col>
              <b-col md="8">
                <div class="cambiar-contrasena">
                  <form @submit.prevent="onChangePassword">
                    <div>
                      <label for="actual">Contraseña Actual</label>
                      <input
                        type="password"
                        id="actual"
                        v-model="form.password"
                        required
                      />
                    </div>

                    <div>
                      <label for="nueva">Nueva Contraseña</label>
                      <input
                        type="password"
                        id="nueva"
                        v-model="form.new_password"
                        required
                      />
                    </div>

                    <div>
                      <label for="confirmar">Confirmar Nueva Contraseña</label>
                      <input
                        type="password"
                        id="confirmar"
                        v-model="form.confirm_password"
                        required
                      />
                      <p v-if="!checkPassword && form.confirm_password">
                        Las contraseñas no coinciden
                      </p>
                    </div>

                    <button
                      class="btn btn-sm btn-primary btn-circle"
                      type="submit"
                    >
                      <i class="flaticon2-writing"></i>
                      {{ isLoading ? "Cargando..." : "Actualizar contraseña" }}
                    </button>
                  </form>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </transition>
  </b-row>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import toastr from "toastr";

export default {
  components: {},
  data() {
    return {
      isLoading: false,
      form: {
        password: "",
        new_password: "",
        confirm_password: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
    checkPassword() {
      return (
        this.form.new_password &&
        this.form.confirm_password &&
        this.form.new_password === this.form.confirm_password
      );
    },
  },
  methods: {
    async onChangePassword() {
      if (this.checkPassword) {
        const payload = {
          password_actual: this.form.password,
          new_password: this.form.new_password,
        };
        try {
          const { status, data } = await axios.put("/users/change/password", payload);
          if (status === 200 && data.message === "success" ) {
              toastr.success(data.information);
              this.form.password = "";
              this.form.new_password = "";
              this.form.confirm_password = "";
          } else {
            toastr.warning(data.information);
          }
        } catch (error) {
          toastr.warning(
            "Opps!, sucedio un error al actualizar la contraseña - comuniquese con soporte"
          );
        }
      }
    },
  },
};
</script>
<style scoped>
.flex-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cambiar-contrasena {
  max-width: 400px;
  margin: auto;
}
.cambiar-contrasena input {
  display: block;
  width: 100%;
  margin-bottom: 10px;
}
.cambiar-contrasena p {
  color: red;
  font-size: 0.9em;
}
</style>
